import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  companyId: string;
  id: string;
  body: {
    hiddenAt?: string;
  };
};

const request = ({ companyId, id, body }: RequestDataType) => {
  return new ApiClient()
    .put<ResponseMessageType>(
      `/api/admin_operators/companies/${companyId}/navigation_items/${id}`,
      {
        navigationItem: body,
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisAdminOperatorsNavigationItemsUpdate = ({
  options = {},
}: PropsType = {}): UseMutationResult<ResponseMessageType> => {
  return useMutation(request, { ...options });
};
